import Hero from '../components/home/Hero';
import StatsBar from '../components/home/StatsBar';
import FeaturedCars from '../components/home/FeaturedCars';
import WhyUs from '../components/home/WhyUs';
import { Helmet } from 'react-helmet-async';

export default function Home() {
  return (
    <>
    <Helmet>
            <title>PRG Cars | Affordable Used Cars in Nagpur</title>
            <meta name="description" content="Buy certified used cars in Nagpur at best prices. Browse Maruti, Honda, Toyota and more at PRG Cars, Manish Nagar." />
            <meta name="keywords" content="used cars nagpur, second hand cars nagpur, buy used car nagpur, certified cars nagpur" />
            <link rel="canonical" href="https://prgcars.in/" />

            {/* Open Graph — for WhatsApp/social sharing */}
            <meta property="og:title" content="Used Cars in Nagpur | PRG Cars" />
            <meta property="og:description" content="Certified used cars at best prices in Nagpur." />
            <meta property="og:image" content="https://prgcars.in/og-image.jpg" />
            <meta property="og:url" content="https://prgcars.in/" />
            </Helmet>
      <Hero />
      <StatsBar />
      <FeaturedCars />
      <WhyUs />
    </>
  );
}